import { css } from '@emotion/css';

export const backdropWrapperStyles = css`
  z-index: 1300;
`;

export const setRectStyles = ({ top, left, width, height }: DOMRect) => css`
  top: ${top}px;
  left: ${left}px;
  width: ${width}px;
  height: ${height}px;
`;
